import { env } from './EnvironmentConfig';

export const APP_NAME = 'VOXEL';
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const FILES_URL = env.FILES_URL;

